// @flow
import React from "react";
import SearchDurationArrowIconSvg from "../../../svg/searchDurationArrowIcon.svg";

import styles from "./searchDurationArrowIcon.module.scss";

const SearchDurationArrowIcon = () => {
  return <SearchDurationArrowIconSvg className={styles.base} />;
};

export default SearchDurationArrowIcon;
